import { RequestStatus } from "@/models/request";
import { EUserRole } from "@/modules/authentication/authentication.type";
import { checkPermission } from "@/modules/authentication/components/Permission/checkPermission";
import useAuth from "../authentication/useAuth";
import { useGetListAuthorization } from "../request/useGetListAuthorization";
import { useGetListRequest } from "../request/useGetListRequest";

const useGetRequestNotification = () => {
  const { profile } = useAuth();

  const sharingApprovalPermission = profile
    ? checkPermission(profile, [EUserRole.ADMIN, EUserRole.CREATOR, EUserRole.EXPLORER])
    : false;
  const publishingAuthorizationPermission = profile
    ? checkPermission(profile, [EUserRole.ADMIN, EUserRole.APPROVER])
    : false;

  const { data: sharingApprovalRequest } = useGetListRequest({
    enabledToastError: true,
    filterFn: (d) => d.filter((item) => item.status === RequestStatus.RPending),
  });

  const { data: publishingAuthorizationRequest } = useGetListAuthorization({
    enabledToastError: true,
    filterFn: (d) =>
      d.filter((item) => item.status === RequestStatus.ARPending && item.type === "publish"),
  });

  const isSharingApproval =
    sharingApprovalRequest &&
    sharingApprovalRequest.filter((item) => item.status === RequestStatus.RPending).length > 0;
  const isPublishingAuthorization =
    publishingAuthorizationRequest &&
    publishingAuthorizationRequest.filter(
      (item) => item.status === RequestStatus.ARPending && item.type === "publish"
    ).length > 0;

  return {
    notification:
      (isSharingApproval && sharingApprovalPermission) ||
      (isPublishingAuthorization && publishingAuthorizationPermission) ||
      false,
    sharingApprovalNotification: (isSharingApproval && sharingApprovalPermission) || false,
    publishingAuthorizationNotification:
      (isPublishingAuthorization && publishingAuthorizationPermission) || false,
  };
};

export default useGetRequestNotification;
